import * as __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__ from "date-fns";
function getFormattedDates({ dates, dateFormat, displayNights }) {
    if (!dates) return '';
    if ('from' in dates) {
        const range = dates;
        const fromDate = range.from ? (0, __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__.format)(range.from, dateFormat) : '';
        const toDate = range.to ? (0, __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__.format)(range.to, dateFormat) : '';
        let formattedDates = '';
        if (fromDate && toDate) if (displayNights) {
            const diffInDays = (0, __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__.differenceInCalendarDays)(toDate, fromDate);
            formattedDates = `${fromDate} - ${toDate} (${diffInDays} nights)`;
        } else formattedDates = `${fromDate} - ${toDate}`;
        return formattedDates;
    }
    if (Array.isArray(dates)) return dates.map((date)=>(0, __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__.format)(date, dateFormat)).join(', ');
    return (0, __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__.format)(dates, dateFormat);
}
export { getFormattedDates };
